import {ChangeDetectionStrategy, Component, Directive, ElementRef, input, output, signal, TemplateRef, ViewContainerRef} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {fromEvent, Observable, of, switchMap, takeUntil, tap, timer} from "rxjs";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {eventStopOgPrevent, fileListSomArray} from "felles-ng2/støttefunksjoner/dom";
import {erIkkeNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {Overlay, OverlayRef} from "@angular/cdk/overlay";
import {TemplatePortal} from "@angular/cdk/portal";
import {leverForsinketMedMindreAnnenStrømLeverer} from "felles-ng2/støttefunksjoner/observable";
import {MatIcon} from "@angular/material/icon";

const debug = initDebugger('DraOgSlippFilAktivertMeldingKomponent');


/**
 * Komponent som kan brukes for å lage melding som så kan gis som fragment til {@link DraOgSlippFilDirektiv}
 */
@Component({
    selector: 'dra-og-slipp-fil-aktivert-melding',
    template: `
        <p><ng-content></ng-content></p>
        <mat-icon>{{ ikon() }}</mat-icon>
    `,
    styles: `
        @use "../../../../../styles/web-ng2/mixins/material";
        :host {
            display: block;
            background: #ffffffdd;
            border-radius: 10px;
            padding: 40px;
            text-align: center;
        }
        mat-icon { @include material.mat-icon--størrelse(60px); }
    `,
    standalone: true,
    imports: [
        MatIcon
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DraOgSlippFilAktivertMeldingKomponent {
    ikon = input('cloud_upload')
}
